import { cn } from '@anytag/shared-utils';

export interface CircularProgressProps {
  size?: number;
  speed?: string;
  reversed?: boolean;
  className?: string;
  thickness?: number;
}

export const CircularProgress = ({
  reversed,
  className,
  size = 12,
  speed = '1s',
  thickness = 1
}: CircularProgressProps) => (
  <span
    style={{
      ['--mask' as string]: reversed
        ? `conic-gradient(#fff, #ffffff00), linear-gradient(#fff 0 0) content-box`
        : `conic-gradient(#0000, #000), linear-gradient(#000 0 0) content-box`,
      width: `${size}px`,
      mask: 'var(--mask)',
      padding: `${thickness}mm`,
      WebkitMask: 'var(--mask)',
      maskComposite: 'subtract',
      animationDuration: `${speed}`,
      WebkitMaskComposite: 'subtract'
    }}
    className={cn(
      'box-border block aspect-square rounded-full bg-white',
      reversed ? 'animate-spin-reverse' : 'animate-spin',
      className
    )}
  />
);
